export default __webpack_public_path__ + "static/media/atom-i-info-alt.3e17cc67.svg";